export enum InvoiceDocumentTypeEnum {
  INVOICE = 'INVOICE',
  TRAVEL_AND_EXPENSES = 'TRAVEL_AND_EXPENSES',
  MEDICAL_TRAVEL_REPORT = 'MEDICAL_TRAVEL_REPORT'
}
